import styled from 'styled-components';

export default styled.div`
  textArea {
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    resize: none;
    outline: 0;
    height: 92px;
    border: 3px solid ${(props) => props.theme.colors.grey};
    color: #666666;
    padding: 10px;
    font-size: 12px;

    &:focus {
      color: ${(props) => props.theme.colors.primary};
    }

    .rta__item--selected {
      background-color: #ff0000;
    }
  }

  .rta {
    position: relative;
    .rta__autocomplete {
      position: absolute;
      z-index: 1000;
      .rta__item:last-child {
        border-bottom: none !important;
      }
      .rta__item--selected {
        background-color: ${(props) => props.theme.colors.primary};
        color: white;
      }
      .rta__item-item {
        font-style: italic;
        opacity: 0.5;
      }
      .onTheField,
      .referee,
      .otherMatchFacts {
        font-style: normal;
        opacity: 1;
      }
      .rta__item-item div {
        display: inline-block;
      }
      .rta__item-item-shirt-number {
        width: 20px;
      }
    }
    .icon {
      width: 16px;
      height: 16px;
      top: 3px;
      position: relative;
    }
  }
`;
